<template>
    <div class="project-layout app-content" v-if="agency">
        <template>
            <header class="project-header" >
                <h1>{{ agency.displayName }}</h1>
                <input type="search" name="" v-model="searchText" value="" placeholder="Search"  class="form-control d-none d-sm-block"/>
            </header>
        </template>
        <div class="container-fluid">
            <router-link :to="'/offices?selectedClient='+ queryParams" style="margin-top:15px" v-if="user && user.role !== 'ROLE_AGENT_USER'">
                <button type="button" v-if="true" class="btn btn-quaternary">BACK TO {{agency.client.title}} OFFICES</button>
            </router-link>
            <div class="row">
                <div class="col-12">
                    <template>
                        <header class="pg-header">
                            <h1 class="no-m-b">Campaigns</h1>
                        </header>
                        <div v-if="orders.length === 0 && loading === false">
                            <app-no-data-available
                                :title="`No data available for ${agency.displayName}`"
                                :description="searchText ? `There aren't any results available for the given search query.` : `There aren't any orders availabe to display.`"
                            />
                        </div>
                        <section class="notifications-list campaigns-list">
                            <template>
                                <ol v-if="orders.length > 0">
                                    <li v-for="(order, index) in orders" :key="index" class="row no-m-r no-m-l">
                                        <div class="col-md-9 col-xs-12 mb-1 mt-1">
                                            {{order.campaign && order.campaign.displayName || ""}}
                                            <span v-if="$isAllowed('viewPrices')">
                                                {{ order.packagePrice | formatCurrency }}
                                                <template v-if="hasGst">incl. GST</template>
                                                <template v-else>excl. GST</template>
                                            </span>
                                            <span 
                                                v-if="order.status" 
                                                :class="{
                                                'badge badge-in-progress' : order.status === 'In Progress', 
                                                'badge badge-finished' : order.status === 'Finished', 
                                                'badge badge-upcoming' : order.status === 'Upcoming',
                                                'badge badge-cancelled' : order.status === 'Cancelled',
                                                'badge badge-stopped' : order.status === 'Stopped',
                                                'badge badge-booked' : order.status === 'Booked',
                                                'badge badge-draft' : order.status === 'Draft',
                                                }
                                            ">{{order.status}}</span>  
                                        </div>
                                        <div  class="col-md-3 col-xs-12 text-right mb-1 mt-1">
                                            <a href="#" target="_blank" class="btn-link" @click.prevent="goToDashboard(order)">View Dashboard</a>
                                        </div>
                                    </li>
                                </ol>
                                <div v-else>
                                    <p>No campaigns</p>
                                </div>
                            </template>
                        </section>
                    </template>
                </div>
                <div class="col-12">
                    <div class="col-12 mt-4" v-if="orders.length > 0 && hasMorePages">
                        <div class="btn-container" style="text-align: center">
                        <button
                            class="btn-primary btn"
                            @click="currentCursor = nextCursor"
                        >
                            Load more
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OrderService from '../../services/orders';
    import CampaignPerimeters from '../../configs/Perimeters/campaigns';
    import { refreshPageMixin } from '../../mixins/refreshPage';
    import { FilterBuilder } from "../../helpers/FilterBuilder"
    import AppNoDataAvailable from "../AppComponents/AppNoDataAvailable.vue";
    import ApiMixin from "../../mixins/ApiMixin"

    export default {
        mixins: [refreshPageMixin, ApiMixin],
        perimeters: [CampaignPerimeters],
        props: ["agency"],
        components: {
            AppNoDataAvailable
        },
        computed: {
            queryParams() {
                return JSON.stringify({id: this.agency.client.id, title: this.agency.client.title});
            },
            hasGst(){
                return this.agency ? this.agency.includeGst : true;
            }
        },
        data() {
            return {
                searchText:"",
                searchTimeout: null,
                orders: [],
                currentCursor: 0,
                nextCursor: 0,
                user: null,
                hasMorePages: false,
                filterBuilder: new FilterBuilder()
            }
        },
        methods: {
            goToDashboard(order){
                if (order.campaignType == 'property' || order.campaignType == 'property extend' || order.campaignType == 'property just sold') {
                    this.$router.push('/office/' + this.$route.params.agency + '/property-campaigns/' + order.campaign.id);
                } else {
                    this.$router.push('/office/' + this.$route.params.agency + '/agent-campaigns/' + order.campaign.id);
                }
            },
            async getOrders(){
                await this.request(
                    OrderService.getOrdersByAgency,
                    this.$route.params.agency, 
                    this.currentCursor,
                    this.filterBuilder.get()
                );
            }
        },
        watch: {
            currentCursor: {
                handler(value) {
                    if (value === 0) return;
                    this.getOrders();
                }
            },
            searchText: {
                handler(value) {
                    this.orders = [];
                    if (!value) {
                        this.filterBuilder.removeFilter("searchText");
                    } else {
                        this.filterBuilder.updateFilter("searchText", value);
                    }
                    clearTimeout(this.searchTimeout);
                    this.searchTimeout = setTimeout(() => {
                        this.currentCursor = 0;
                        this.nextCursor = 0;
                        this.getOrders();
                    }, 1000)
                }
            },
            response: {
                handler(response) {
                    this.orders = this.currentCursor === 0 ? response.data : [...this.orders, ...response.data];
                    const hasNext = response.meta.cursor.hasOwnProperty("next");
                    this.hasMorePages = hasNext;
                    if (hasNext) {
                        this.nextCursor = response.meta.cursor.next.cursor;
                    }
                }
            }
        },
        mounted() {
            this.getOrders();
            this.user = this.$store.getters.getUser;
            window.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
</script>

<style lang="css" scoped>
.badge-draft {
    background-color: #ffb30f;
    color: black;
}
</style>
